export default "/static/webpack/media/skill-model.nb.708fcc70.png";